import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../services/auth';

const ERROR_MESSAGES = {
    provider_error: 'El proveedor de identidad Keycloak rechazó o canceló el inicio de sesión.',
    forbidden_group: 'Tu cuenta de Moval está autenticada pero no pertenece al grupo autorizado de esta aplicación (app:GESTION_EMBARGOS_N63).',
    token_exchange_failed: 'No se pudo completar el intercambio OIDC con Keycloak. Inténtalo de nuevo.',
};

export default function Login() {
    const [username, setUsername] = useState('dev@moval.es');
    const [error, setError] = useState('');
    const [searchParams] = useSearchParams();
    const { authConfig, login, loginSso } = useAuth();
    const navigate = useNavigate();

    const authErrorCode = searchParams.get('auth_error');
    const activeError = error || (authErrorCode ? (ERROR_MESSAGES[authErrorCode] || 'Error de autenticación SSO') : '');

    const handleMockSubmit = async (e) => {
        e.preventDefault();
        setError('');
        try {
            const user = await login(username);
            if (user) navigate('/');
        } catch (_) {
            setError('Error de autenticación');
        }
    };

    return (
        <div className="login-page">
            <div className="login-card">
                <h1>Gestión Embargos N63</h1>
                <p style={{ color: 'var(--color-text-muted)', fontSize: '0.9rem', marginBottom: 20, textAlign: 'center' }}>
                    Acceso corporativo Moval (Cuaderno 63 AEB)
                </p>
                {activeError && (
                    <div className="badge badge-danger" style={{ marginBottom: 16, display: 'block', whiteSpace: 'normal', padding: '10px 12px', lineHeight: 1.4 }}>
                        {activeError}
                    </div>
                )}
                {authConfig?.mode === 'mock' ? (
                    <form onSubmit={handleMockSubmit}>
                        <div className="form-group">
                            <label>Usuario (Modo Desarrollo)</label>
                            <input
                                type="text"
                                value={username}
                                onChange={e => setUsername(e.target.value)}
                                required
                            />
                        </div>
                        <button type="submit" className="btn btn-primary" style={{ width: '100%' }}>
                            Entrar (Dev Mock)
                        </button>
                    </form>
                ) : (
                    <div>
                        <button
                            type="button"
                            onClick={loginSso}
                            className="btn btn-primary"
                            style={{ width: '100%', padding: '12px 16px', fontWeight: 600 }}
                        >
                            Iniciar sesión con Moval SSO (Keycloak)
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
}
